import { createStore } from 'vuex'
import moduleCommon from './modules/moduleCommon'
import moduleRegister from './modules/moduleRegister'

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    moduleCommon,
    moduleRegister
  }
})
